import React from "react";
import { getDate } from "../../../utils/dateUtils";
import CountdownTimer from "../CountdownTimer";
import { env } from "../../../env";
import bg_drawing_img from "../../../assets/images/lotto90/lotto90_drawing_bg.png";

import { useLotto90 } from "../../../store/lotto90/Lotto90Context";

const platformType = env.PLATFORM_TYPE;

const MobileDashboardDrawingLotto90 = () => {
    const {
        drawing: { number, isDrawing, detail, tempIndex },
        oldResult,
        newResult,
        countDownTimer,
        t,
        playSound
    } = useLotto90();


    return (
        <div className="lotto90-mobile-wrapper">

            {/* Background + Drawing wrapper */}
            <div className="l90-mobile-bg-wrapper">

                {/* Background follows placeholder height */}
                <div
                    className="l90-mobile-bg"
                    style={{
                        backgroundImage: `url(${require("../../../assets/images/lotto90/lotto90_v1_bg.png")})`
                    }}
                />

                {/* Foreground content */}
                <div className="l90-mobile-drawing-sync">

                    {/* === HEADER === */}
                    <div className="l90-mobile-header">
                        <div>
                            <div className="d-flex align-items-center logo">
                                <span>
                                    <img
                                        src={require(`../../../assets/images/logo/${platformType}.png`)}
                                        alt="logo"
                                    />
                                </span>
                                <span className="lotto-name kh-font-battambang font-moul">
                                    ៩០ សំណាង
                                </span>
                            </div>

                            <div>
                                <span className="p-2 left-date-sec">{getDate(oldResult?.drawAt)}</span>
                                <span className="p-2 left-ticket-sec">{oldResult?.drawCode}</span>
                            </div>
                        </div>

                        {/* Timer */}
                            {!isDrawing && newResult ? (
                                <div className="l90-mobile-timer ">
                                    <div className="count-down-mobile">
                                        <CountdownTimer
                                            playSound={playSound}
                                            isDrawing={isDrawing}
                                            time={countDownTimer}
                                            time-sec-title-mobile
                                        />
                                    </div>
                                   <div className="d-flex">
                                       <span className="right-date-sec">{getDate(newResult?.drawAt)}</span>
                                       <span className="right-ticket-sec">{newResult?.drawCode}</span>
                                   </div>
                                </div>
                            ) : (
                                <div className="l90-mobile-timer">
                                    <div className="time-sec-title-mobile">
                                        {t("labels:drawing.lotto90.drawing")}
                                    </div>
                                </div>
                            )}

                    </div>

                    {/* === MAIN DRAWING BOARD === */}
                    <div className="l90-mobile-drawing-board">
                        <img className="draw-img" src={bg_drawing_img} alt="__" />

                        <div className="draw-number-mobile">
                            {oldResult?.detail?.split(",").map((e, i) => {
                                let show;
                                const ps = oldResult.posts[i].postCode;

                                if (isDrawing) {
                                    if (i === tempIndex) {
                                        show =
                                            number === "?"
                                                ? ""
                                                : number.toString().padStart(2, "0");
                                    } else if (!detail.includes(parseInt(e))) {
                                        show = "";
                                    } else {
                                        show = e;
                                    }
                                } else {
                                    show = e;
                                }

                                return (
                                    <div
                                        key={i}
                                        className={`number-render-mobile lotto90-post-${ps}`}
                                    >
                                        {show}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default MobileDashboardDrawingLotto90;
